/* eslint-disable */
export default {
  dialer: '撥號盤',
  allCalls: '所有通話',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
